import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardSection } from 'components/Card';
import Message from 'components/Message';
import Button from 'components/Button';
import InlineSvg from 'react-inlinesvg';
import { bem } from 'helpers/class-name';
import { ICONS } from 'constants/icons';
import { googleCtaMessages, iCalCtaMessages } from './CalSyncTutorialModal.messages';
import { getCurrentStepScreen } from './SteppedScreens';
import './CalSyncTutorialModal.scss';

export const CALSYNC_TUTORIAL_MODAL_NAME = 'CalSyncTutorialModal';

const { block, element } = bem('calsync-tutorial-modal');
const MAX_STEPS = 4;

const CalSyncTutorialModal = ({ venueId, flowType = 'ical', isMobile, isComplete, closeModal, markAsComplete }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const handleStepIncrease = () => {
    const newStep = currentStep + 1;
    if (newStep === MAX_STEPS) {
      markAsComplete();
      closeModal();
      return;
    }

    setCurrentStep(newStep);
  };

  const renderPagination = () => {
    const pagination = [];
    for (let i = 0; i < MAX_STEPS; i += 1) {
      pagination.push(
        <InlineSvg
          key={`pagination-${i}`}
          className={element('pagination-icon', { current: currentStep === i })}
          src={ICONS.filledDot}
        />
      );
    }

    return pagination;
  };

  const buttonStyle = isMobile ? 'primary' : 'link';
  const ctaMessages = flowType === 'google' ? googleCtaMessages : iCalCtaMessages;
  const CurrentScreen = getCurrentStepScreen({ currentStep, flowType });

  return (
    <Card className={block()} flush>
      <CardSection flush className={element('header')}>
        <InlineSvg
          className={element('close-icon', { hidden: !isComplete })}
          src={ICONS.cardsClose}
          onClick={() => closeModal()}
        />
      </CardSection>

      <CardSection className={element('content')}>
        <CurrentScreen venueId={venueId} />
      </CardSection>

      <CardSection flush className={element('navigation')}>
        <div className={element('pagination')}>{renderPagination()}</div>
        <div className={element('cta')}>
          <Button styled={buttonStyle} onClick={handleStepIncrease}>
            <Message message={ctaMessages[currentStep].cta} />
            <InlineSvg
              className={element('cta-icon', { disabled: currentStep === MAX_STEPS - 1 })}
              src={ICONS.rightArrow}
            />
          </Button>
        </div>
      </CardSection>
    </Card>
  );
};

CalSyncTutorialModal.propTypes = {
  venueId: PropTypes.number,
  flowType: PropTypes.oneOf(['google', 'ical']),
  isMobile: PropTypes.bool,
  isComplete: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  markAsComplete: PropTypes.func,
};

export default CalSyncTutorialModal;
